import { PrintDataEntitas } from "./Booking";
import { Pagination } from "./Pagination";

export class Handover {
  handoverId: number;
  handoverDestinationPartnerName: string;
  handoverVendorCode: string;
  handoverTotalSTT: number;
  handoverTotalPiece: number;
  handoverTotalGrossWeight: number;
  handoverTotalVolumeWeight: number;
  handoverCreatedAt: string;
  handoverCreatedBy: string;
  handoverIsSupportPrintResi: boolean;
  vendorOrderStatus: string;
  isViewDetailVendorOrder: boolean;
  isRetryAvailable: boolean;
  handoverStatus: string;
  isViewDetailHandover: boolean;
  handoverTotalSttFailed: number;
  handoverVendorName: string;

  constructor(
    handoverId: number,
    handoverDestinationPartnerName: string,
    handoverVendorCode: string,
    handoverTotalSTT: number,
    handoverTotalPiece: number,
    handoverTotalGrossWeight: number,
    handoverTotalVolumeWeight: number,
    handoverCreatedAt: string,
    handoverCreatedBy: string,
    handoverIsSupportPrintResi: boolean,
    vendorOrderStatus = "",
    isViewDetailVendorOrder = false,
    isRetryAvailable = false,
    handoverStatus = "",
    isViewDetailHandover = false,
    handoverTotalSttFailed = 0,
    handoverVendorName = ""
  ) {
    this.handoverId = handoverId;
    this.handoverDestinationPartnerName = handoverDestinationPartnerName;
    this.handoverVendorCode = handoverVendorCode;
    this.handoverTotalSTT = handoverTotalSTT;
    this.handoverTotalPiece = handoverTotalPiece;
    this.handoverTotalGrossWeight = handoverTotalGrossWeight;
    this.handoverTotalVolumeWeight = handoverTotalVolumeWeight;
    this.handoverCreatedAt = handoverCreatedAt;
    this.handoverCreatedBy = handoverCreatedBy;
    this.handoverIsSupportPrintResi = handoverIsSupportPrintResi;
    this.vendorOrderStatus = vendorOrderStatus;
    this.isViewDetailVendorOrder = isViewDetailVendorOrder;
    this.isRetryAvailable = isRetryAvailable;
    this.handoverStatus = handoverStatus;
    this.isViewDetailHandover = isViewDetailHandover;
    this.handoverTotalSttFailed = handoverTotalSttFailed;
    this.handoverVendorName = handoverVendorName;
  }
}

export class HandoverList {
  pagination: Pagination;
  data: Handover[];

  constructor(pagination: Pagination, data: Handover[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class HandoverDetail {
  handoverManifestId = 0;
  handoverManifestTotalStt = 0;
  handoverTotalPiece = 0;
  handoverManifestTotalGrossWeight = 0;
  handoverManifestTotalVolumeWeight = 0;
  handoverPartnerName = "";
  handoverDestinationPartnerName = "";
  handoverVendorCode = "";
  handoverArrivalCitycode = "";
  handoverArrivalCityName = "";
  handoverOriginCityCode = "";
  handoverOriginCityName = "";
  handoverCreatedAt = "";
  handoverCreatedBy = "";
  stt: HandoverSttResult[] = [];
  handoverIsSupportPrintResi = false;
  handoverStatus = "";
  constructor(fields?: Partial<HandoverDetail>) {
    Object.assign(this, fields);
  }
}

export class HandoverSttResult {
  sttId: string;
  sttNo: string;
  sttProductType: string;
  sttTotalPiece: string;
  sttDestinationCityId: string;
  sttDestinationCityName: string;
  sttWoodPacking: string;
  sttCommodityCode: string;
  sttCommodityName: string;
  sttCommodityNameEn: string;
  sttGrossWeight: number;
  sttVolumeWeight: number;
  sttChargeableWeight: number;
  sttCodAmount: number;
  sttPiece: SttPiece[];
  sttElexysNo?: string;
  sttOriginCityId: string;
  sttOriginCityName: string;
  constructor(
    sttId: string,
    sttNo: string,
    sttProductType: string,
    sttTotalPiece: string,
    sttDestinationCityId: string,
    sttDestinationCityName: string,
    sttWoodPacking: string,
    sttCommodityCode: string,
    sttCommodityName: string,
    sttCommodityNameEn: string,
    sttGrossWeight: number,
    sttVolumeWeight: number,
    sttChargeableWeight: number,
    sttCodAmount: number,
    sttPiece: SttPiece[],
    sttOriginCityId: string,
    sttOriginCityName: string,
    sttElexysNo?: string
  ) {
    this.sttId = sttId;
    this.sttNo = sttNo;
    this.sttProductType = sttProductType;
    this.sttTotalPiece = sttTotalPiece;
    this.sttDestinationCityId = sttDestinationCityId;
    this.sttDestinationCityName = sttDestinationCityName;
    this.sttWoodPacking = sttWoodPacking;
    this.sttCommodityCode = sttCommodityCode;
    this.sttCommodityName = sttCommodityName;
    this.sttCommodityNameEn = sttCommodityNameEn;
    this.sttGrossWeight = sttGrossWeight;
    this.sttVolumeWeight = sttVolumeWeight;
    this.sttChargeableWeight = sttChargeableWeight;
    this.sttCodAmount = sttCodAmount;
    this.sttPiece = sttPiece;
    this.sttElexysNo = sttElexysNo;
    this.sttOriginCityId = sttOriginCityId;
    this.sttOriginCityName = sttOriginCityName;
  }
}

export class SttPiece {
  sttPieceId: number;
  sttPieceGrossWeight: number;
  sttPieceVolumeWeight: number;
  sttPieceNo: number;
  constructor(
    sttPieceId: number,
    sttPieceGrossWeight: number,
    sttPieceVolumeWeight: number,
    sttPieceNo: number
  ) {
    this.sttPieceId = sttPieceId;
    this.sttPieceGrossWeight = sttPieceGrossWeight;
    this.sttPieceVolumeWeight = sttPieceVolumeWeight;
    this.sttPieceNo = sttPieceNo;
  }
}

export class SttDetailData {
  sttId: number;
  sttNumber: string;
  product: string;
  totalPieces: number;
  originCityId: string;
  destinationCityId: string;
  destinationCity: string;
  woodPacking: string;
  commodityCode: string;
  commodity: string;
  totalGrossWeight: number;
  totalVolumeWeight: number;
  chargeableWeight: number;
  codAmount: number;
  sttLastStatusId: string;
  bookedAt: string;
  piece: PieceDetail[];
  sttNoRefExternal: string;
  sttElexysNumber?: string;
  constructor(
    sttId: number,
    sttNumber: string,
    product: string,
    totalPieces: number,
    originCityId: string,
    destinationCityId: string,
    destinationCity: string,
    woodPacking: string,
    commodityCode: string,
    commodity: string,
    totalGrossWeight: number,
    totalVolumeWeight: number,
    chargeableWeight: number,
    codAmount: number,
    sttLastStatusId: string,
    bookedAt: string,
    piece: PieceDetail[],
    sttNoRefExternal: string,
    sttElexysNumber?: string
  ) {
    this.sttId = sttId;
    this.sttNumber = sttNumber;
    this.product = product;
    this.totalPieces = totalPieces;
    this.originCityId = originCityId;
    this.destinationCityId = destinationCityId;
    this.destinationCity = destinationCity;
    this.woodPacking = woodPacking;
    this.commodityCode = commodityCode;
    this.commodity = commodity;
    this.totalGrossWeight = totalGrossWeight;
    this.totalVolumeWeight = totalVolumeWeight;
    this.chargeableWeight = chargeableWeight;
    this.codAmount = codAmount;
    this.sttLastStatusId = sttLastStatusId;
    this.bookedAt = bookedAt;
    this.piece = piece;
    this.sttNoRefExternal = sttNoRefExternal;
    this.sttElexysNumber = sttElexysNumber;
  }
}

export class PieceDetail {
  sttPieceId: number;
  grossWeight: number;
  volumeWeight: number;
  sttPieceNumber: string;
  lastStatus: string;
  pieceNo: string;
  constructor(
    sttPieceId: number,
    grossWeight: number,
    volumeWeight: number,
    sttPieceNumber: string,
    lastStatus: string,
    pieceNo: string
  ) {
    this.sttPieceId = sttPieceId;
    this.grossWeight = grossWeight;
    this.volumeWeight = volumeWeight;
    this.sttPieceNumber = sttPieceNumber;
    this.lastStatus = lastStatus;
    this.pieceNo = pieceNo;
  }
}

export class ResponseUpdate {
  handoverId: number;
  totalSttSuccess: number;
  totalSttFailed: number;
  sttFailed: Array<string>;
  constructor(
    handoverId: number,
    totalSttSuccess: number,
    totalSttFailed: number,
    sttFailed: Array<string>
  ) {
    this.handoverId = handoverId;
    this.totalSttSuccess = totalSttSuccess;
    this.totalSttFailed = totalSttFailed;
    this.sttFailed = sttFailed;
  }
}

export class PartnerVendorList {
  code: string;
  partnerId: number;
  partnerName: string;
  type: string;
  cityCode: string;
  vendorName: string;
  apiIntegration: boolean;
  constructor(
    code: string,
    partnerId: number,
    partnerName: string,
    type: string,
    cityCode: string,
    vendorName: string,
    apiIntegration: boolean
  ) {
    this.code = code;
    this.partnerId = partnerId;
    this.partnerName = partnerName;
    this.type = type;
    this.cityCode = cityCode;
    this.vendorName = vendorName;
    this.apiIntegration = apiIntegration;
  }
}

// Per-STT vendor API call outcome, mirrors hydra's model.FailedVendorSttStatus*.
export const FAILED_VENDOR_STT_STATUS_SUCCESS = "success";
export const FAILED_VENDOR_STT_STATUS_FAILED = "failed";

export class HandoverFailedVendorSttItem {
  sttNo = "";
  status = "";
  reason = "";
  reasonEn = "";
  message = "";
  retryAvailable = false;

  constructor(fields?: Partial<HandoverFailedVendorSttItem>) {
    Object.assign(this, fields);
  }
}

export class HandoverFailedVendorSttResponse {
  vendorOrderStatus = "";
  isViewDetailVendorOrder = false;
  isRetryAvailable = false;
  stt: HandoverFailedVendorSttItem[] = [];

  constructor(fields?: Partial<HandoverFailedVendorSttResponse>) {
    Object.assign(this, fields);
  }
}


export class VendorDl {
  shipmentId = "";
  productCode = "";
  deliveryConfirmationNo = "";
  deliveryDepotCode = "";

  primarySortCode = "";
  secondarySortCode = "";

  constructor(fields?: Partial<VendorDl>) {
    Object.assign(this, fields);
  }
}

export class SttData {
  sttVendorSttNo = "";
  sttVendorReferenceNo = "";
  resi = "";
  detail = new PrintDataEntitas();
  awbPending = false;
  message = "";
  messageEn = "";
  retryAvailable = false;

  constructor(fields?: Partial<SttData>) {
    Object.assign(this, fields);

    if (fields?.detail) {
      this.detail = new PrintDataEntitas(fields.detail);
    }
  }
}

export class FailedVendorSttItem {
  sttNo = "";
  sttVendorReferenceNo = "";
  status = "";
  message = "";
  reason = "";
  reasonEn = "";
  retryAvailable = false;
  lastStatusUpdatedAt = "";

  constructor(fields?: Partial<FailedVendorSttItem>) {
    Object.assign(this, fields);
  }
}

export class FailedVendorStt {
  vendorOrderStatus = "";
  isViewDetailVendorOrder = false;
  isRetryAvailable = false;
  stt: FailedVendorSttItem[] = [];
  pagination: Pagination = new Pagination(1, 100, 0);

  constructor(fields?: Partial<FailedVendorStt>) {
    Object.assign(this, fields);
  }
}

export class HandoverFailedSttItem {
  sttNo = "";
  shipmentId = "";
  productType = "";
  commodityName = "";
  totalPiece = 0;
  grossWeight = 0;
  volumeWeight = 0;
  reason = "";
  reasonEn = "";

  constructor(fields?: Partial<HandoverFailedSttItem>) {
    Object.assign(this, fields);
  }
}

export class HandoverFailedStt {
  handoverId = 0;
  totalFailed = 0;
  failedStt: HandoverFailedSttItem[] = [];

  constructor(fields?: Partial<HandoverFailedStt>) {
    Object.assign(this, fields);
  }
}

export class RetryHandoverVendorResult {
  success = false;
  code = 0;
  message = "";
  handoverId = 0;
  sttNo = "";
  sttNos: string[] = [];
  vendorCode = "";
  vendorOrderStatus = "";
  totalSttProcessing = 0;

  constructor(fields?: Partial<RetryHandoverVendorResult>) {
    Object.assign(this, fields);
  }
}
